import { PageType } from 'app-types';

export const PAGE_IN_VIEW = 'PAGE_IN_VIEW' as const;

export const pageSelected = (page: string, pageType: PageType) => {
  return {
    type: PAGE_IN_VIEW,
    payload: {
      page,
      type: pageType,
    },
  };
};
